import { Injectable, EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CertificationClientConfigDto, ConfigClient } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  config!: CertificationClientConfigDto;

  constructor(private readonly configClient: ConfigClient) {}

  async loadConfig(): Promise<CertificationClientConfigDto> {
    this.config = await firstValueFrom(this.configClient.clientConfig());

    return this.config;
  }

  get fiscalYearDescription(): string | undefined {
    const fiscalYearDescription = this.config.fiscalYearDescription;

    if (!fiscalYearDescription) {
      return undefined;
    }

    return fiscalYearDescription;
  }
}

export const ConfigServiceProvider: EnvironmentProviders = provideAppInitializer(() => {
  const initializerFn = ((appConfigSvc: ConfigService) => {
    return async () => {
      await appConfigSvc.loadConfig();
    };
  })(inject(ConfigService));
  return initializerFn();
});
